import { AxiosResponse } from 'axios'
import { ApiResult, Guid, QueryableTargetField } from '../api'
import { useApiClient } from './useApiClient'

export const useQueryDocumentApi = () => {
  const apiClient = useApiClient()

  const queryDocument = (
    customerAgencyId: Guid,
    documentType: DocumentType,
    targetField: QueryableTargetField,
    fieldValue: string,
  ) => {
    if (targetField == QueryableTargetField.DocumentId) {
      return apiClient.request<void, AxiosResponse<ApiResult<string>>>({
        url: `api/customerAgencies/${customerAgencyId}/documents/${documentType}/${fieldValue}`,
        method: 'get',
        withCredentials: true,
      })
    } else if (targetField == QueryableTargetField.DocumentExternalId) {
      return apiClient.request<void, AxiosResponse<ApiResult<string>>>({
        url: `api/customerAgencies/${customerAgencyId}/documents/${documentType}/${fieldValue}`,
        method: 'get',
        withCredentials: true,
      })
    } else {
      return apiClient.request<void, AxiosResponse<ApiResult<string>>>({
        url: `api/customerAgencies/${customerAgencyId}/documents/${documentType}/query?targetField=${targetField}&fieldValue=${fieldValue}`,
        method: 'get',
        withCredentials: true,
      })
    }
  }

  return {
    queryDocument,
  }
}
